import { createContext } from "react";

export interface iVoiceRemoteUser {
	username: string;
	volume: number;
	isSpeaking: boolean;
	audioPower: number;
}

export interface iVoiceSocketServerContextType {
	connected: boolean;
	microphoneActive: boolean;
	microphoneMuted: boolean;
	microphoneVolume: number;
	speakingUsername: string;
	users: iVoiceRemoteUser[];
	userName: string;
	room: string;
	setUserName: (userName: string) => void;
	setRoom: (room: string) => void;
	Actions: {
		connect: (room?: string, userName?: string) => void;
		disconnect: () => void;
		startMicrophone: () => Promise<void>;
		stopMicrophone: () => void;
		muteMicrophone: () => void;
		unmuteMicrophone: () => void;
		toggleMicrophoneMute: () => void;
		setUserVolume: (username: string, volume: number) => void;
	};
}

const defaultValue: iVoiceSocketServerContextType = {
	connected: false,
	microphoneActive: false,
	microphoneMuted: false,
	microphoneVolume: 0,
	speakingUsername: "",
	users: [],
	userName: "Test",
	room: "GLOBAL",
	setUserName: () => undefined,
	setRoom: () => undefined,
	Actions: {
		connect: () => undefined,
		disconnect: () => undefined,
		startMicrophone: async () => undefined,
		stopMicrophone: () => undefined,
		muteMicrophone: () => undefined,
		unmuteMicrophone: () => undefined,
		toggleMicrophoneMute: () => undefined,
		setUserVolume: () => undefined,
	},
};

export const VoiceSocketServerContext =
	createContext<iVoiceSocketServerContextType>(defaultValue);